<template>
  <pt-integral-goods-form class="pt-integral-goods-form__page" :isEdit="is_edit" :id="id"></pt-integral-goods-form>
</template>

<script>
import PtIntegralGoodsForm from "cps/integral-mall-manage/pt-goods-of-integral/pt-integral-goods-form";
export default {
  name: "pt-integral-goods-form__view",
  components: {
    "pt-integral-goods-form": PtIntegralGoodsForm
  },
  props: {
    isEdit: {
      type: String
    },
    id: {
      type: String
    }
  },
  data() {
    return {
      is_edit: this.isEdit === "true"
    };
  },
  created() {
    console.log("this.isEdit",this.is_edit);
  }
};
</script>
